<template>
  <div class="tw-text-xs tw-flex tw-items-center">
    <div class="tw-flex tw-space-x-2 2xl:tw-space-x-3 tw-pr-2">
      <tooltip-hover
        :text="$t('total_mods', { ugc: ugcName(null, false, true).value })"
      >
        <item-card-footer-stat
          :label="$t('total_mods', { ugc: ugcName(null, false, true).value })"
          icon="layer-group"
          :text="numberFormatter(stats?.mods_total || 0)"
        />
      </tooltip-hover>

      <tooltip-hover class="tw-hidden xs:tw-block" :text="$t('total_filesize')">
        <item-card-footer-stat
          :label="$t('total_filesize')"
          icon="database"
          :text="humanFilesize(filesize)"
        />
      </tooltip-hover>

      <tooltip-hover :text="$t('followers')">
        <item-card-footer-stat
          :label="$t('followers')"
          icon="users"
          :text="numberFormatter(stats?.followers_total || 0)"
        />
      </tooltip-hover>

      <tooltip-hover
        class="tw-hidden lg:tw-block"
        :text="`${$t('compat_rating')} (${stats.ratings_total} ${$t('vote', stats.ratings_total)})`"
      >
        <item-card-footer-stat
          :label="`${$t('compat_rating')} (${stats.ratings_total} ${$t('vote', stats.ratings_total)})`"
          :class="compatibilityIcon.class"
          :icon="compatibilityIcon.icon"
          :text="isNaN(compatibilityRating) ? 'N/A' : `${compatibilityRating}%`"
        />
      </tooltip-hover>
    </div>
  </div>
</template>

<script>
import ItemCardFooterStat from '@components/List/ItemCardFooterStat.vue'
import { numberFormatter, humanFilesize } from '@helpers/utils.js'
import TooltipHover from '@components/Message/TooltipHover.vue'
import { useResourceValue } from '@composables'
import { computed, toRefs } from 'vue'
export default {
  components: {
    ItemCardFooterStat,
    TooltipHover,
  },
  props: {
    stats: {
      type: Object,
      default: () => ({}),
    },
    browseId: {
      type: String,
      required: true,
    },
    filesize: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { stats } = toRefs(props)
    const { ugcName } = useResourceValue()

    const compatibilityRating = computed(() =>
      Math.floor(
        (stats.value.ratings_positive / stats.value.ratings_total) * 100
      )
    )

    const compatibilityIcon = computed(() => {
      if (isNaN(compatibilityRating.value)) {
        return { class: 'tw-text-dark-text', icon: 'question-circle' }
      }
      if (compatibilityRating.value < 60 && stats.value.ratings_total > 0) {
        return { class: 'tw-text-danger', icon: 'exclamation-circle' }
      }
      if (compatibilityRating.value < 70) {
        return { class: 'tw-text-warning', icon: 'exclamation-circle' }
      }
      return { class: 'tw-text-success', icon: 'check-circle' }
    })

    return {
      compatibilityRating,
      compatibilityIcon,
      numberFormatter,
      humanFilesize,
      ugcName,
    }
  },
}
</script>
